import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { changeFormField, changeFormFieldValue } from 'apps/auth/actions/formAction';
import InputText from 'apps/auth/components/form-multi/InputText';
import {
    COUNTRY_OF_RESIDENCE_CLICKED,
    COUNTRY_OF_RESIDENCE_SELECTED,
    SELECT_COUNTRY_OF_RESIDENCE_SCREEN_SHOWN,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { COUNTRY_OF_RESIDENCE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import update from 'apps/auth/helpers/Immutability';
import { useApp } from 'apps/auth/hooks/selectors';

import CountryDropBoxList from './CountryDropBoxList';
import ModalComponent from '../utils/ModalComponent';

const CountryDropBox = (props) => {
    const { currentSiteSection } = useApp();
    const [customField, setField] = useState({ ...props.field });
    const [isOpenedDropbox, toggleDropbox] = useState(false);

    const REMOVE_POST_CODE_FOR_COUNTRY = [784];

    useEffect(() => {
        if (props.field.value && props.country_list) {
            const matched = props.country_list.find((item) => item.id === parseInt(props.field.value));
            if (matched) {
                setField((prev) => update(prev, { value: { $set: matched.name } }));
            }
        }
    }, [props.field.value]);

    useEffect(() => {
        if (isOpenedDropbox) {
            sendEvent(SELECT_COUNTRY_OF_RESIDENCE_SCREEN_SHOWN, props.country?.nameEn);
        }
    }, [isOpenedDropbox]);

    const selectItem = (e, item) => {
        sendEvent(COUNTRY_OF_RESIDENCE_SELECTED, item.nameEn);
        const hideIndex = REMOVE_POST_CODE_FOR_COUNTRY.find(function (element) {
            return parseInt(item.id) === element;
        });
        if (props.fieldPostCode && hideIndex) {
            props.changeFormField(
                props.formName,
                update(props.fieldPostCode, {
                    mandatory: { $set: false },
                    visible: { $set: false },
                    value: { $set: '   ' },
                }),
            );
        } else if (props.fieldPostCode && !props.fieldPostCode.visible) {
            props.changeFormField(
                props.formName,
                update(props.fieldPostCode, {
                    mandatory: { $set: true },
                    visible: { $set: true },
                    value: { $set: '' },
                }),
            );
        }
        props.changeFormFieldValue(props.formName, item.id, props.field.name);
        setField(update(props.field, { value: { $set: item.name } }));
        if (props.selectHandler) {
            props.selectHandler(item);
        }
        closeDropbox();
    };

    const showDropbox = () => {
        sendEvent(COUNTRY_OF_RESIDENCE_CLICKED, props.country?.nameEn);
        toggleDropbox(true);
    };

    const closeDropbox = () => {
        toggleDropbox(false);
    };

    const sendEvent = (eventName, eventParam) => {
        if (currentSiteSection === 'login') {
            amplitude.getInstance().logEvent(eventName, { [COUNTRY_OF_RESIDENCE]: eventParam });
        }
    };

    return (
        <>
            <InputText
                isReadOnly={props.readOnly}
                onClick={showDropbox}
                field={customField}
                customValue={props.customValue}
                formName={props.formName}
                autoFocus={props.focus}
                onFocus={props.onFocus}
                onChange={props.onChange}
                validateOnBlur={false}
                onBlur={props.onBlur}
                isNewInput
                isPseudoSelect
                alwaysHasHint={props.alwaysHasHint}
            />
            {isOpenedDropbox && (
                <ModalComponent canCloseModal={false}>
                    <CountryDropBoxList
                        selectItem={selectItem}
                        searchPlaceholder={props.searchPlaceholder}
                        searchDropBoxEmpty={props.searchDropBoxEmpty}
                        items={props.field.strapiField ? props.field.items : props.country_list}
                        isStrapiField={props.field.strapiField}
                        id={props.field.id}
                        name={props.field.name}
                        onCloseButtonClick={closeDropbox}
                        clearFieldsOnCountrySelect={props.clearFieldsOnCountrySelect}
                        field={props.field}
                    />
                </ModalComponent>
            )}
        </>
    );
};
const mapStateToProps = (state, ownProps) => {
    return {
        fieldPostCode: state.form[ownProps.formName].fields['post_code'],
        searchPlaceholder: state.messages.jsMessages['site.field.search.placeholder'],
        searchDropBoxEmpty: state.messages.jsMessages['site.search.dropdox.empty'],
        country_list: state.extra.country_list,
    };
};
export default connect(mapStateToProps, {
    changeFormFieldValue,
    changeFormField,
})(CountryDropBox);
